<template>
  <div :dir="isRtl != false ? 'rtl' : 'ltr'" :class="['relative w-full deployment-channels-selector-dropdown-container']">
    <button 
      type="button" 
      class="btn w-full justify-start font-normal text-left h-auto py-2 px-3 min-h-0"
      @click="toggleDropdown"
      aria-haspopup="listbox"
      :aria-expanded="isOpen != false"
    >
      <div class="flex items-center space-x-2 w-full">
        <div class="flex items-center min-w-0 flex-1">
          <span class="inline-flex justify-center items-center w-7 h-7 rounded-md bg-base-300 dark:bg-gray-700 flex-shrink-0">
            <Icon icon="heroicons:cursor-arrow-rays-20-solid" class="w-4 h-4 text-base-content" />
          </span>
          <div class="min-w-0 flex-1" :class="isRtl === true ? 'text-right' : 'text-left'">
            <span class="block text-sm font-medium">
              {{ t('deploymentChannels.selector.title', 'Deployment Channels') }}
            </span>
            <span class="block text-xs text-base-content opacity-70">
              <template v-if="(selectedSummary.length > 0)">
                <span class="channel-tags" :class="isRtl === true ? 'justify-end' : 'justify-start'">
                  <span v-for="ch in availableChannels" :key="ch.id" v-show="isSelected(ch.id) === true" :class="['channel-tag','whitespace-nowrap', (isRtl === true ? 'ml-1' : 'mr-1') ]">
                    <Icon :icon="ch.icon" class="icon" />
                    <span>{{ ch.displayName }}</span>
                    <span v-if="(ch.id === 'Whatsapp' || ch.id === 'Whatsapp Voice') && (selectedWhatsappSourceId !== null)" class="opacity-70">{{ selectedWhatsappDisplay }}</span>
                    <span v-if="ch.id === 'Phone' && (selectedPhoneSourceId !== null)" class="opacity-70">{{ selectedPhoneDisplay }}</span>
                  </span>
                </span>
              </template>
              <template v-else>
                {{ t('deploymentChannels.selector.placeholder', 'Select channels') }}
              </template>
            </span>
          </div>
        </div>
        <Icon icon="heroicons:chevron-down-20-solid" class="w-5 h-5 text-base-content opacity-60 flex-shrink-0 ml-auto" />
      </div>
    </button>

    <transition>
      <div 
        v-if="isOpen === true"
         class="bg-base-100 dark:bg-gray-800 shadow-lg rounded-md border border-base-300 dark:border-gray-700 deployment-channels-options-list overflow-y-auto"
        :style="channelsPanelStyle"
        ref="dropdownListRef"
      >
        <div class="py-1 space-y-1">
          <div 
            v-for="ch in availableChannels" 
            :key="ch.id"
            class="card-as-row mx-1 rounded-md transition-all duration-150 ease-in-out"
            :class="isChannelEnabled(ch.id) === true ? 'hover:bg-base-200 dark:hover:bg-gray-700' : 'opacity-50 cursor-not-allowed'" style="text-align: justify;"
            :title="isChannelEnabled(ch.id) === true ? '' : t('deploymentChannels.common.locked', 'Not approved for this organization')"
          >
            <div class="p-3">
              <div class="flex items-center space-x-4 channel-row">
                <div class="flex-shrink-0">
                  <span class="inline-flex justify-center items-center w-8 h-8 rounded-lg bg-base-300 dark:bg-gray-600">
                    <Icon :icon="ch.icon" class="w-5 h-5 text-base-content" />
                  </span>
                </div>
                <div class="flex-grow overflow-hidden w-full" :class="isRtl === true ? 'text-right' : 'text-left'">
                  <h3 class="text-sm font-semibold leading-tight">{{ ch.displayName }}</h3>
                  <p class="text-xs mt-0.5 text-base-content opacity-70">
                    {{ ch.description }}
                  </p>
                  
                </div>
                <div class="ml-auto">
                  <template v-if="ch.id === 'Whatsapp' || ch.id === 'Whatsapp Voice'">
                    <button 
                      type="button" 
                      class="btn"
                      :disabled="isChannelEnabled(ch.id) !== true"
                      :title="isChannelEnabled(ch.id) === true ? '' : t('deploymentChannels.common.locked', 'Not approved for this organization')"
                      @click.stop.prevent="isChannelEnabled(ch.id) === true ? openWhatsAppSelection(ch.id) : null"
                    >
                      {{ selectedWhatsappSourceId !== null ? t('deploymentChannels.whatsapp.change','Change') : t('deploymentChannels.whatsapp.connect','Connect') }}
                    </button>
                  </template>
                  <template v-else-if="ch.id === 'Phone'">
                    <button 
                      type="button" 
                      class="btn"
                      :disabled="isChannelEnabled(ch.id) !== true"
                      :title="isChannelEnabled(ch.id) === true ? '' : t('deploymentChannels.common.locked', 'Not approved for this organization')"
                      @click.stop.prevent="isChannelEnabled(ch.id) === true ? openPhoneSelection() : null"
                    >
                      {{ selectedPhoneSourceId !== null ? t('deploymentChannels.phone.change','Change') : t('deploymentChannels.phone.connect','Connect') }}
                    </button>
                  </template>
                   <template v-else-if="ch.id === 'Email'">
                     <button type="button" class="btn" :disabled="isChannelEnabled(ch.id) !== true" :title="isChannelEnabled(ch.id) === true ? '' : t('deploymentChannels.common.locked', 'Not approved for this organization')" @click.stop.prevent="isChannelEnabled(ch.id) === true ? openEmailInfo() : null">{{ t('deploymentChannels.email.connect','Connect') }}</button>
                   </template>
                  <template v-else>
                    <button
                      type="button"
                      class="btn"
                      :disabled="isChannelEnabled(ch.id) !== true"
                      :title="isChannelEnabled(ch.id) === true ? '' : t('deploymentChannels.common.locked', 'Not approved for this organization')"
                      @click.stop.prevent="toggleChannel(ch.id)"
                    >
                      {{ isSelected(ch.id) === true ? t('deploymentChannels.common.deactivate','Deactivate') : ch.id === 'Web' ? t('deploymentChannels.web.connect','Connect') : t('deploymentChannels.common.activate','Activate') }}
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>

  <WhatsAppNumberPickerModal 
    :visible="showWhatsAppModal"
    :items="availableWhatsapp"
    :loading="loadingNumbers"
    :currentId="selectedWhatsappSourceId"
    @close="cancelWhatsApp"
    @confirm="onWhatsAppConfirm"
  />

  <WhatsAppNumberPickerModal 
    :visible="showPhoneModal"
    :items="availablePhone"
    :loading="loadingPhone"
    :currentId="selectedPhoneSourceId"
    mode="phone"
    @close="cancelPhone"
    @confirm="onPhoneConfirm"
  />
  
  <transition>
    <div v-if="showEmailModal === true" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-base-100 dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md">
        <div class="flex items-center mb-4">
          <span class="inline-flex w-9 h-9 rounded-lg items-center justify-center bg-base-300 dark:bg-gray-700 mr-3">
            <Icon icon="tabler:mail" class="w-5 h-5 text-base-content" />
          </span>
          <h3 class="text-lg font-semibold">{{ t('deploymentChannels.email.title','Email') }}</h3>
        </div>
        <p class="text-sm mb-6">{{ t('deploymentChannels.email.contactSupport','please contact support for email setup.') }}</p>
        <div class="flex justify-end space-x-2">
          <button type="button" class="btn" @click="closeEmailInfo">{{ t('common.close','Close') }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { Icon } from '@iconify/vue/dist/offline';
import { useI18n } from '@/i18n';
import axios from '../api/axiosInstance';
import { useToast } from 'vue-toastification';
import { globalState } from '@/globalState';
import WhatsAppNumberPickerModal from './WhatsAppNumberPickerModal.vue';

const props = defineProps({
  selectedChannels: {
    type: Array,
    default: () => []
  },
  agentId: {
    type: String,
    default: ''
  },
  whatsappSourceId: {
    type: Number,
    default: null
  },
  whatsappNumber: {
    type: String,
    default: ''
  },
  phoneSourceId: {
    type: Number,
    default: null
  },
  phoneNumber: {
    type: String,
    default: ''
  },
  enabledChannels: {
    type: Array,
    default: null
  },
  allowedChannels: {
    type: Array,
    default: null
  }
});

const emit = defineEmits(['update:selectedChannels','update:whatsappSourceId','update:phoneSourceId']);

const isOpen = ref(false);
const dropdownListRef = ref(null);
const { t, currentLanguage } = useI18n();
const isRtl = computed(() => (['he','ar'].includes(currentLanguage.value) === true) ? true : false);
const channelsPanelStyle = computed(() => {
  const alignment = isRtl.value === true ? { right: '0' } : { left: '0' };
  return {
    position: 'absolute',
    zIndex: 265,
    top: 'calc(100% + 8px)',
    width: '100%',
    ...alignment
  };
});
const toast = useToast();
const phoneSourceTypes = ['twilioPhone', 'phonePartner', 'phoneCustomSip', 'sipTrunk', 'sonarixPhone', 'genovisePhone', 'phone'];

function normalizeSourceId(value) {
  if (value === null || value === undefined) {
    return null;
  }
  const parsed = Number(value);
  if (Number.isFinite(parsed) !== true) {
    return null;
  }
  return Math.floor(parsed);
}

function isSameSourceId(left, right) {
  const normalizedLeft = normalizeSourceId(left);
  const normalizedRight = normalizeSourceId(right);
  if (normalizedLeft === null || normalizedRight === null) {
    return false;
  }
  return normalizedLeft === normalizedRight;
}

const rawAvailableChannels = ref([
  {
    id: 'Web Voice Agent',
    displayName: t('deploymentChannels.channels.webVoiceAgent.name', 'Web Voice Agent'),
    description: t('deploymentChannels.channels.webVoiceAgent.desc', 'Voice agent in the web chat'),
    icon: 'tabler:microphone'
  },
  {
    id: 'Whatsapp',
    displayName: t('deploymentChannels.channels.whatsapp.name', 'Whatsapp'),
    description: t('deploymentChannels.channels.whatsapp.desc', 'WhatsApp messaging'),
    icon: 'tabler:brand-whatsapp'
  },
  {
    id: 'Whatsapp Voice',
    displayName: t('deploymentChannels.channels.whatsappVoice.name', 'WhatsApp Voice'),
    description: t('deploymentChannels.channels.whatsappVoice.desc', 'AI voice calls through WhatsApp'),
    icon: 'tabler:brand-whatsapp'
  },
  {
    id: 'Telegram',
    displayName: t('deploymentChannels.channels.telegram.name', 'Telegram'),
    description: t('deploymentChannels.channels.telegram.desc', 'Telegram messages'),
    icon: 'tabler:brand-telegram'
  },
  {
    id: 'Telegram Voice',
    displayName: t('deploymentChannels.channels.telegramVoice.name', 'Telegram Voice'),
    description: t('deploymentChannels.channels.telegramVoice.desc', 'AI voice calls through Telegram'),
    icon: 'tabler:brand-telegram'
  },
  {
    id: 'Phone',
    displayName: t('deploymentChannels.channels.phone.name', 'Phone'),
    description: t('deploymentChannels.channels.phone.desc', 'Phone support'),
    icon: 'tabler:phone'
  },
  {
    id: 'Email',
    displayName: t('deploymentChannels.channels.email.name', 'Email'),
    description: t('deploymentChannels.channels.email.desc', 'Email channel'),
    icon: 'tabler:mail'
  }
]);

const availableChannels = computed(() => {
  if (Array.isArray(props.allowedChannels) && props.allowedChannels.length > 0) {
    return rawAvailableChannels.value.filter(ch => props.allowedChannels.includes(ch.id));
  }
  return rawAvailableChannels.value;
});

function isChannelEnabled(id) {
  if (Array.isArray(props.enabledChannels) !== true) {
    return true;
  }
  return props.enabledChannels.includes(id) === true;
}

const selectedSummary = computed(() => {
  const selected = Array.isArray(props.selectedChannels) === true ? props.selectedChannels : [];
  const names = availableChannels.value.filter(c => (selected.includes(c.id) === true)).map(c => c.displayName);
  return names.join(', ');
});

const selectedWhatsappDisplayOverride = ref('');
const selectedWhatsappDisplay = computed(() => {
  if (typeof selectedWhatsappDisplayOverride.value === 'string' && selectedWhatsappDisplayOverride.value.trim().length > 0) {
    return selectedWhatsappDisplayOverride.value;
  }
  const item = availableWhatsapp.value.find(it => isSameSourceId(it.sourceId, selectedWhatsappSourceId.value) === true);
  if (item !== undefined) {
    if (item.number !== undefined && item.number !== null && String(item.number).length > 0) { return item.number; }
    if (item.display !== undefined && item.display !== null && String(item.display).length > 0) { return item.display; }
  }
  if (typeof props.whatsappNumber === 'string' && props.whatsappNumber.trim().length > 0) { return props.whatsappNumber; }
  return '';
});

const selectedPhoneDisplayOverride = ref('');
const selectedPhoneDisplay = computed(() => {
  if (typeof selectedPhoneDisplayOverride.value === 'string' && selectedPhoneDisplayOverride.value.trim().length > 0) {
    return selectedPhoneDisplayOverride.value;
  }
  const item = availablePhone.value.find(it => isSameSourceId(it.sourceId, selectedPhoneSourceId.value) === true);
  if (item !== undefined) {
    if (item.number !== undefined && item.number !== null && String(item.number).length > 0) { return item.number; }
    if (item.display !== undefined && item.display !== null && String(item.display).length > 0) { return item.display; }
  }
  if (typeof props.phoneNumber === 'string' && props.phoneNumber.trim().length > 0) { return props.phoneNumber; }
  return '';
});

const toggleDropdown = () => {
  isOpen.value = isOpen.value === true ? false : true;
};

function isSelected(id) {
  if (Array.isArray(props.selectedChannels) === false) return false;
  return (props.selectedChannels.includes(id) === true);
}

async function toggleChannel(id) {
  if (isChannelEnabled(id) !== true) {
    return;
  }
  const current = Array.isArray(props.selectedChannels) === true ? props.selectedChannels.slice() : [];
  const exists = current.includes(id) === true;
  if (exists === true) {
    if (id === 'Whatsapp') {
      if (current.includes('Whatsapp Voice') !== true) {
        selectedWhatsappSourceId.value = null;
        emit('update:whatsappSourceId', null);
      }
    }
    if (id === 'Whatsapp Voice') {
      if (current.includes('Whatsapp') !== true) {
        selectedWhatsappSourceId.value = null;
        emit('update:whatsappSourceId', null);
      }
    }
    if (id === 'Phone') {
      selectedPhoneSourceId.value = null;
      emit('update:phoneSourceId', null);
    }
    const idx = current.indexOf(id);
    if (idx > -1) current.splice(idx, 1);
  } else {
    if (id === 'Whatsapp' || id === 'Whatsapp Voice') {
      await openWhatsAppSelection(id);
      return;
    } else if (id === 'Phone') {
      await openPhoneSelection();
      return;
    } else {
      current.push(id);
    }
  }
  emit('update:selectedChannels', current);;
}

const handleClickOutside = (event) => {
  if (dropdownListRef.value !== null) {
    if (isOpen.value === true) {
      if (dropdownListRef.value.contains(event.target) === false) {
        if (event.target.closest('.deployment-channels-selector-dropdown-container button[aria-haspopup="listbox"]') === null) {
          isOpen.value = false
        }
      }
    }
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside, true);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside, true);
});

const showWhatsAppModal = ref(false);
const availableWhatsapp = ref([]);
const selectedWhatsappSourceId = ref(normalizeSourceId(props.whatsappSourceId));
const pendingWhatsappChannel = ref('Whatsapp');
const loadingNumbers = ref(false);
const showPhoneModal = ref(false);
const showEmailModal = ref(false);
const availablePhone = ref([]);
const loadingPhone = ref(false);
const selectedPhoneSourceId = ref(normalizeSourceId(props.phoneSourceId));

async function openWhatsAppSelection(channelId = 'Whatsapp') {
  pendingWhatsappChannel.value = channelId === 'Whatsapp Voice' ? 'Whatsapp Voice' : 'Whatsapp';
  showWhatsAppModal.value = true;
  loadingNumbers.value = true;
  try {
    const res = await axios.get(`${globalState.apiEndpoint}/api/communicationSources/available`, { params: { type: 'whatsapp' } });
    const raw = Array.isArray(res.data) === true ? res.data : [];
    const filtered = raw.filter(it => {
      if (pendingWhatsappChannel.value === 'Whatsapp Voice') {
        return it.type === 'whatsappMeta' && it.voiceEnabled === true;
      }
      return it.type === 'whatsappMeta' || it.type === 'whatsappSmooch' || it.type === 'whatsapp99Digital';
    });
    availableWhatsapp.value = filtered.map(it => {
      const sidRaw = it.sourceId !== undefined && it.sourceId !== null ? it.sourceId : (it.sourceid !== undefined && it.sourceid !== null ? it.sourceid : (it.id !== undefined && it.id !== null ? it.id : null));
      const sid = normalizeSourceId(sidRaw);
      return {
        sourceId: sid,
        type: it.type,
        display: it.display !== undefined && it.display !== null ? it.display : (it.name !== undefined && it.name !== null ? it.name : ''),
        number: it.number !== undefined && it.number !== null ? it.number : ''
      };
    }).filter(x => x.sourceId !== null);
    const curId = selectedWhatsappSourceId.value !== null ? selectedWhatsappSourceId.value : normalizeSourceId(props.whatsappSourceId);
    if (curId !== null) {
      const exists = availableWhatsapp.value.some(it => isSameSourceId(it.sourceId, curId) === true);
      if (exists === false && pendingWhatsappChannel.value !== 'Whatsapp Voice') {
        availableWhatsapp.value.unshift({
          sourceId: curId,
          type: '',
          display: typeof props.whatsappNumber === 'string' && props.whatsappNumber.length > 0 ? props.whatsappNumber : String(curId),
          number: typeof props.whatsappNumber === 'string' && props.whatsappNumber.length > 0 ? props.whatsappNumber : ''
        });
      }
    }
    
  } catch (error) {
    availableWhatsapp.value = [];
  } finally {
    loadingNumbers.value = false;
  }
}

function cancelWhatsApp() {
  showWhatsAppModal.value = false;
}

async function openPhoneSelection() {
  showPhoneModal.value = true;
  loadingPhone.value = true;
  try {
    const res = await axios.get(`${globalState.apiEndpoint}/api/communicationSources/available`, { params: { type: 'phoneNumber' } });
    const raw = Array.isArray(res.data) === true ? res.data : [];
    const filtered = raw.filter(it => phoneSourceTypes.includes(String(it.type)) === true);
    availablePhone.value = filtered.map(it => {
      const sidRaw = it.sourceId !== undefined && it.sourceId !== null ? it.sourceId : (it.sourceid !== undefined && it.sourceid !== null ? it.sourceid : (it.id !== undefined && it.id !== null ? it.id : null));
      const sid = normalizeSourceId(sidRaw);
      return {
        sourceId: sid,
        type: it.type,
        display: it.display !== undefined && it.display !== null ? it.display : (it.name !== undefined && it.name !== null ? it.name : ''),
        number: it.number !== undefined && it.number !== null ? it.number : ''
      };
    }).filter(x => x.sourceId !== null);
    const curId = selectedPhoneSourceId.value !== null ? selectedPhoneSourceId.value : normalizeSourceId(props.phoneSourceId);
    if (curId !== null) {
      const exists = availablePhone.value.some(it => isSameSourceId(it.sourceId, curId) === true);
      if (exists === false) {
        availablePhone.value.unshift({
          sourceId: curId,
          type: '',
          display: typeof props.phoneNumber === 'string' && props.phoneNumber.length > 0 ? props.phoneNumber : String(curId),
          number: typeof props.phoneNumber === 'string' && props.phoneNumber.length > 0 ? props.phoneNumber : ''
        });
      }
    }
  } catch (error) {
    availablePhone.value = [];
  } finally {
    loadingPhone.value = false;
  }
}

function cancelPhone() { showPhoneModal.value = false; }

async function onPhoneConfirm(payload) {
  if (payload == null) {
    return;
  }
  const rawSid = payload.sourceId;
  if (rawSid === null || rawSid === undefined || Number.isFinite(Number(rawSid)) === false) {
    selectedPhoneSourceId.value = null;
    selectedPhoneDisplayOverride.value = '';
    emit('update:phoneSourceId', null);
    const current = Array.isArray(props.selectedChannels) === true ? props.selectedChannels.slice() : [];
    const idx = current.indexOf('Phone');
    if (idx > -1) { current.splice(idx, 1); }
    emit('update:selectedChannels', current);
    showPhoneModal.value = false;
    toast.success(t('deploymentChannels.phone.unbound', 'Phone unbound'));
    return;
  }
  const coerced = parseInt(String(rawSid).trim(), 10);
  selectedPhoneSourceId.value = coerced;
  selectedPhoneDisplayOverride.value = typeof payload.number === 'string' ? payload.number : '';
  emit('update:phoneSourceId', selectedPhoneSourceId.value);
  const current = Array.isArray(props.selectedChannels) === true ? props.selectedChannels.slice() : [];
  if (current.includes('Phone') === false) {
    current.push('Phone');
  }
  emit('update:selectedChannels', current);
  showPhoneModal.value = false;
  toast.success(t('deploymentChannels.phone.selected', 'Phone number selected'));
}

function openEmailInfo() {
  isOpen.value = false;
  showEmailModal.value = true;
}

function closeEmailInfo() {
  showEmailModal.value = false;
}

async function onWhatsAppConfirm(payload) {
  if (payload == null) {
    return;
  }
  const rawSid = payload.sourceId;
  if (rawSid === null || rawSid === undefined || Number.isFinite(Number(rawSid)) === false) {
    selectedWhatsappSourceId.value = null;
    selectedWhatsappDisplayOverride.value = '';
    emit('update:whatsappSourceId', null);
    const current = Array.isArray(props.selectedChannels) === true ? props.selectedChannels.slice() : [];
    const whatsappIndex = current.indexOf('Whatsapp');
    if (whatsappIndex > -1) { current.splice(whatsappIndex, 1); }
    const whatsappVoiceIndex = current.indexOf('Whatsapp Voice');
    if (whatsappVoiceIndex > -1) { current.splice(whatsappVoiceIndex, 1); }
    emit('update:selectedChannels', current);
    showWhatsAppModal.value = false;
    toast.success(t('deploymentChannels.whatsapp.unbound', 'WhatsApp unbound'));
    return;
  }
  const coerced = parseInt(String(rawSid).trim(), 10);
  selectedWhatsappSourceId.value = coerced;
  selectedWhatsappDisplayOverride.value = typeof payload.number === 'string' ? payload.number : '';
  emit('update:whatsappSourceId', selectedWhatsappSourceId.value);
  const current = Array.isArray(props.selectedChannels) === true ? props.selectedChannels.slice() : [];
  if (current.includes(pendingWhatsappChannel.value) === false) {
    current.push(pendingWhatsappChannel.value);
  }
  emit('update:selectedChannels', current);
  showWhatsAppModal.value = false;
  toast.success(t('deploymentChannels.whatsapp.selected', 'WhatsApp number selected'));
}

async function unbindWhatsapp(){
  if (selectedWhatsappSourceId.value !== null) {
    selectedWhatsappSourceId.value = null;
    selectedWhatsappDisplayOverride.value = '';
    emit('update:whatsappSourceId', null);
    const current = Array.isArray(props.selectedChannels) === true ? props.selectedChannels.slice() : [];
    const whatsappIndex = current.indexOf('Whatsapp');
    if (whatsappIndex > -1) { current.splice(whatsappIndex, 1); }
    const whatsappVoiceIndex = current.indexOf('Whatsapp Voice');
    if (whatsappVoiceIndex > -1) { current.splice(whatsappVoiceIndex, 1); }
    emit('update:selectedChannels', current);
    toast.success(t('deploymentChannels.whatsapp.unbound', 'WhatsApp unbound'));
  }
}

watch(() => props.whatsappSourceId, (v) => {
  const normalizedValue = normalizeSourceId(v);
  if (normalizedValue !== selectedWhatsappSourceId.value) {
    selectedWhatsappSourceId.value = normalizedValue;
  }
});

watch(() => props.whatsappNumber, (n) => {
  selectedWhatsappDisplayOverride.value = typeof n === 'string' ? n.trim() : '';
});

watch(() => props.phoneSourceId, (v) => {
  const normalizedValue = normalizeSourceId(v);
  if (normalizedValue !== selectedPhoneSourceId.value) {
    selectedPhoneSourceId.value = normalizedValue;
  }
});

watch(() => props.phoneNumber, (n) => {
  selectedPhoneDisplayOverride.value = typeof n === 'string' ? n.trim() : '';
});
</script>

<style scoped>
.deployment-channels-options-list {
  max-height: 400px;
  margin-top: 8px;
  overflow-y: auto;
}
.card-as-row {
  display: block;
}
.channel-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 4px;
}
.channel-tag {
  display: inline-flex;
  align-items: center;
  margin-bottom: 4px;
  padding: 6px 6px;
  border-radius: 9999px;
  background: var(--fallback-b2, #eef2f7);
  color: #111827;
  font-size: 12px;
}

.channel-tag > * + * { margin-inline-start: 6px; }
.channel-tag .icon {
  width: 16px; height: 16px;
}
.deployment-channels-selector-dropdown-container[dir='ltr'] .channel-tag {
  margin-inline-start: 0;
  margin-inline-end: 0;
  margin-left: 0;
  margin-right: 0;
}
.deployment-channels-selector-dropdown-container[dir='rtl'] .channel-tag {
  margin-right: 0;
  margin-left: 6px;
}
</style>


